import * as cx from 'classnames';
import * as React from 'react';
import styles from './ScoreNumber.mscss';

export const ScoreNumberType = {
    Big: 'big' as 'big',
    Medium: 'medium' as 'medium',
    Small: 'small' as 'small',
};
export type ScoreNumberType = (typeof ScoreNumberType)[keyof typeof ScoreNumberType];

interface OwnProps {
    score: number;
    type: ScoreNumberType;
    onClick?: any;
    className?: string;
}

const getColorStyle = (score: number): string => {
    if (score >= 8) {
        return styles['ScoreNumber--8-10'];
    }
    if (score >= 5) {
        return styles['ScoreNumber--5-7'];
    }
    if (score >= 2) {
        return styles['ScoreNumber--2-4'];
    }
    return styles['ScoreNumber--1'];
};

const getTypeStyle = (type: ScoreNumberType): string => {
    if (type === ScoreNumberType.Big) {
        return styles['ScoreNumber--big'];
    }
    if (type === ScoreNumberType.Medium) {
        return styles['ScoreNumber--medium'];
    }
    if (type === ScoreNumberType.Small) {
        return styles['ScoreNumber--small'];
    }
};

export class ScoreNumber extends React.Component<OwnProps> {

    public render() {
        const {onClick, score, type} = this.props;

        const colorStyle = getColorStyle(score);
        const typeStyle = getTypeStyle(type);

        const className = cx(styles.ScoreNumber, colorStyle, typeStyle, this.props.className);

        return (
            <div className={className} onClick={onClick}>
                {score}
            </div>
        );
    }
}
